// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ads-modal__container[data-v-0c92b132]{position:fixed;background-color:rgba(0,0,0,.55);top:0;right:0;bottom:0;left:0;z-index:999999;pointer-events:none;display:flex;flex-direction:column;justify-content:center;align-items:center;width:100%;height:100dvh;padding:1rem;padding-top:32px}.ads-modal[data-v-0c92b132]{z-index:1000000;width:96%;max-width:1024px;position:relative;margin:0 1rem;overflow:visible;pointer-events:all;padding:0!important;border-radius:14px}", ""]);
// Exports
module.exports = exports;
